import Vue from "vue";
import VeeValidate from "vee-validate";
import tc from "vee-validate/dist/locale/zh_TW";
import Datepicker from "vuejs-datepicker";
import {formatNumber, isValidNumber, AsYouType, getNumberType} from "libphonenumber-js";
import intPhoneMetadata from "libphonenumber-js/metadata.full.json";
import App from "./App.vue";

//Vue.use(VeeValidate);

const dict = {
    zh_TW:{
        messages:{
            required: (field) => "請填寫" + field,
            regex: (field) => "請填寫有效" + field,
//            max: (field, error) => "不可填寫多於" + error[0] + "個字的" + field,
            max: (field, error) => "請填寫有效" + field,
//            min: (field, error) => field + "的最少字數為" + error[0]
            min: (field, error) => "請填寫有效" + field,
            alpha_spaces: (field) => "請填寫有效" + field,
            email: (field) => "請填寫有效" + field,
            numeric: (field) => "請填寫有效" + field,
            size: function(field, error){
                var t, r, u, i = error[0];
                return "未能" + field + "，文件過大，請上傳不大於" + (t = i, r = 1024, u = 0 == (t = Number(t) * r) ? 0 : Math.floor(Math.log(t) / Math.log(r)), 1 * (t / Math.pow(r, u)).toFixed(2) + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][u]) + "的文件"
            },
            mimes: (field) => "未能" + field + "，上傳格式不正確，請上傳JPG、GIF、PNG格式",
            image: (field) => "未能" + field + "，上傳格式不正確，請上傳JPG、GIF、PNG格式",
            ext: (field) => "未能" + field + "，上傳格式不正確，請上傳JPG、GIF、PNG格式",
        }
    }
}

VeeValidate.Validator.localize({zh_TW: tc});

VeeValidate.Validator.localize(dict);

Vue.use(VeeValidate, {locale: "zh_TW"});

Vue.component("datepicker", Datepicker);

//Vue.use(VeeValidate);

Vue.config.productionTip = false;

//new Vue({
//  render: h => h(App)
//}).$mount("#app");

new Vue({
    el: "#app",
    inherit: true,
    components: {
        App
    },
    data:{
    },
    created: function(){
        VeeValidate.Validator.extend("gender", {
            getMessage: (field) => "請選擇" + field,
            validate: (input, args) => {
                if(input == "MR" || input == "MS"){
                    return true;
                }else{
                    return false;
                }
            }
        });
        VeeValidate.Validator.extend("nationality", {
            getMessage: (field) => "請填寫或選擇正確的" + field,
            validate: (input, args) => {
                const countries = [
                {order: "1", value: "China", displayName: "中國"},
                {order: "2", value: "Macau", displayName: "澳門"},
                {order: "3", value: "Afghanistan", displayName: "阿富汗"},
                {order: "4", value: "Albania", displayName: "阿爾巴尼亞"},
                {order: "5", value: "Algeria", displayName: "阿爾及利亞"},
                {order: "6", value: "Andorra", displayName: "安道爾"},
                {order: "7", value: "Angola", displayName: "安哥拉"},
                {order: "8", value: "Anguilla", displayName: "安圭拉"},
                {order: "9", value: "Antarctica", displayName: "南極洲"},
                {order: "10", value: "Antigua and Barbuda", displayName: "安提瓜和巴布達"},
                {order: "11", value: "Argentina", displayName: "阿根廷"},
                {order: "12", value: "Armenia", displayName: "亞美尼亞"},
                {order: "14", value: "Aruba", displayName: "阿魯巴"},
                {order: "15", value: "Australia", displayName: "澳大利亞"},
                {order: "16", value: "Austria", displayName: "奧地利"},
                {order: "17", value: "Azerbaijan", displayName: "阿塞拜疆"},
                {order: "18", value: "Bahamas", displayName: "巴哈馬"},
                {order: "19", value: "Bahrain", displayName: "巴林"},
                {order: "20", value: "Bangladesh", displayName: "孟加拉國"},
                {order: "21", value: "Barbados", displayName: "巴巴多斯"},
                {order: "22", value: "Belarus", displayName: "白俄羅斯"},
                {order: "23", value: "Belgium", displayName: "比利時"},
                {order: "24", value: "Belize", displayName: "伯利茲"},
                {order: "25", value: "Benin", displayName: "貝寧"},
                {order: "26", value: "Bermuda", displayName: "百慕大"},
                {order: "27", value: "Bhutan", displayName: "不丹"},
                {order: "28", value: "Bolivia", displayName: "玻利維亞"},
                {order: "30", value: "Bosnia and Herzegovina", displayName: "波斯尼亞和黑塞哥維那"},
                {order: "31", value: "Botswana", displayName: "博茨瓦納"},
                {order: "32", value: "Bouvet Island", displayName: "布維島"},
                {order: "33", value: "Brazil", displayName: "巴西"},
                {order: "34", value: "British indian Ocean Territory", displayName: "英屬印度洋領土"},
                {order: "35", value: "British Virgin Islands", displayName: "英屬維爾京群島"},
                {order: "36", value: "Brunei Darussalam", displayName: "文萊"},
                {order: "37", value: "Bulgaria", displayName: "保加利亞"},
                {order: "38", value: "Burkina Faso", displayName: "布基納法索"},
                {order: "39", value: "Burundi", displayName: "布隆迪"},
                {order: "40", value: "Cambodia", displayName: "柬埔寨"},
                {order: "41", value: "Cameroon", displayName: "喀麥隆"},
                {order: "42", value: "Canada", displayName: "加拿大"},
                {order: "43", value: "Cape Verde", displayName: "佛得角"},
                {order: "44", value: "Cayman Islands", displayName: "開曼群島"},
                {order: "45", value: "Central Africa", displayName: "中非"},
                {order: "46", value: "Chad", displayName: "乍得"},
                {order: "47", value: "Chile", displayName: "智利"},
                {order: "48", value: "Christmas Island", displayName: "聖誕島"},
                {order: "49", value: "Cocos(Keeling) Islands", displayName: "科科斯(基林)群島"},
                {order: "50", value: "Colombia", displayName: "哥倫比亞"},
                {order: "51", value: "Comoros", displayName: "科摩羅"},
                {order: "52", value: "Congo", displayName: "剛果"},
                {order: "53", value: "Cook Islands", displayName: "庫克群島"},
                {order: "54", value: "Costa Rica", displayName: "哥斯達黎加"},
                {order: "55", value: "Cote d Ivoire", displayName: "科特迪瓦"},
                {order: "56", value: "Croatia", displayName: "克羅地亞"},
                {order: "57", value: "Cuba", displayName: "古巴"},
                {order: "58", value: "Cyprus", displayName: "塞浦路斯"},
                {order: "59", value: "Czech Repoublic", displayName: "捷克"},
                {order: "60", value: "Denmark", displayName: "丹麥"},
                {order: "61", value: "Djibouti", displayName: "吉布提"},
                {order: "62", value: "Dominica", displayName: "多米尼克"},
                {order: "63", value: "Dominican Republic", displayName: "多米尼加共和國"},
                {order: "64", value: "East Timor", displayName: "東帝汶"},
                {order: "65", value: "Ecuador", displayName: "厄瓜多爾"},
                {order: "66", value: "Egypt", displayName: "埃及"},
                {order: "67", value: "El Salvador", displayName: "薩爾瓦多"},
                {order: "68", value: "Equatorial Guinea", displayName: "赤道幾內亞"},
                {order: "69", value: "Eritrea", displayName: "厄立特里亞"},
                {order: "70", value: "Estonia", displayName: "愛沙尼亞"},
                {order: "71", value: "Ethiopia", displayName: "埃塞俄比亞"},
                {order: "72", value: "Faroe Islands", displayName: "法羅群島"},
                {order: "73", value: "Fiji", displayName: "斐濟"},
                {order: "74", value: "Finland", displayName: "芬蘭"},
                {order: "75", value: "France", displayName: "法國"},
                {order: "76", value: "French Guiana", displayName: "法屬圭亞那"},
                {order: "77", value: "French Polynesia", displayName: "法屬波利尼西亞"},
                {order: "78", value: "French Southern Territories", displayName: "法屬南部領土"},
                {order: "79", value: "Gabon", displayName: "加蓬"},
                {order: "80", value: "Gambia", displayName: "岡比亞"},
                {order: "81", value: "Georgia", displayName: "格魯吉亞"},
                {order: "82", value: "Germany", displayName: "德國"},
                {order: "83", value: "Ghana", displayName: "加納"},
                {order: "84", value: "Gibraltar", displayName: "直布羅陀"},
                {order: "85", value: "Greece", displayName: "希臘"},
                {order: "86", value: "Greenland", displayName: "格陵蘭"},
                {order: "87", value: "Grenada", displayName: "格林納達"},
                {order: "88", value: "Guadeloupe", displayName: "瓜德羅普"},
                {order: "89", value: "Guam", displayName: "關島"},
                {order: "90", value: "Guatemala", displayName: "危地馬拉"},
                {order: "91", value: "Guinea", displayName: "幾內亞"},
                {order: "92", value: "Guine-bissau", displayName: "幾內亞比紹"},
                {order: "93", value: "Guyana", displayName: "圭亞那"},
                {order: "94", value: "Haiti", displayName: "海地"},
                {order: "95", value: "Heard islands and Mc Donald Islands", displayName: "赫德島和麥克唐納島"},
                {order: "96", value: "Honduras", displayName: "洪都拉斯"},
                {order: "97", value: "Hungary", displayName: "匈牙利"},
                {order: "98", value: "Iceland", displayName: "冰島"},
                {order: "99", value: "India", displayName: "印度"},
                {order: "100", value: "Indonesia", displayName: "印度尼西亞"},
                {order: "101", value: "Iran", displayName: "伊朗"},
                {order: "102", value: "Iraq", displayName: "伊拉克"},
                {order: "103", value: "Ireland", displayName: "愛爾蘭"},
                {order: "104", value: "Israel", displayName: "以色列"},
                {order: "105", value: "Italy", displayName: "意大利"},
                {order: "106", value: "Jamaica", displayName: "牙買加"},
                {order: "107", value: "Japan", displayName: "日本"},
                {order: "108", value: "Jordan", displayName: "約旦"},
                {order: "109", value: "Kazakhstan", displayName: "哈隆克斯坦"},
                {order: "110", value: "Kenya", displayName: "肯尼亞"},
                {order: "111", value: "Kiribati", displayName: "基里巴斯"},
                {order: "112", value: "Korea,Democratic Peoples Republic of", displayName: "朝鮮"},
                {order: "113", value: "Korea,Republic of", displayName: "韓國"},
                {order: "114", value: "Kuwait", displayName: "科威特"},
                {order: "115", value: "Kyrgyzstan", displayName: "吉爾吉斯斯坦"},
                {order: "116", value: "Lao", displayName: "老撾"},
                {order: "117", value: "Latvia", displayName: "拉脫維亞"},
                {order: "118", value: "Lebanon", displayName: "黎巴嫩"},
                {order: "119", value: "Lesotho", displayName: "萊索托"},
                {order: "120", value: "Liberia", displayName: "利比里亞"},
                {order: "121", value: "Libya", displayName: "利比亞"},
                {order: "122", value: "Liechtenstein", displayName: "列支敦士登"},
                {order: "123", value: "Lithuania", displayName: "立陶宛"},
                {order: "124", value: "Luxembourg", displayName: "盧森堡"},
                {order: "125", value: "Macedonia", displayName: "馬斯頓"},
                {order: "126", value: "Madagascar", displayName: "馬達加斯加"},
                {order: "127", value: "Malawi", displayName: "馬拉維"},
                {order: "128", value: "Malaysia", displayName: "馬來西亞"},
                {order: "129", value: "Maldives", displayName: "馬爾代夫"},
                {order: "130", value: "Mali", displayName: "馬里"},
                {order: "131", value: "Malta", displayName: "馬耳他"},
                {order: "132", value: "Malvinas Islands (Falkland Islands)", displayName: "馬爾維納斯群島(福克蘭群島)"},
                {order: "133", value: "Marshall Islands", displayName: "馬紹爾群島"},
                {order: "134", value: "Martinique", displayName: "馬提尼克"},
                {order: "135", value: "Mauritania", displayName: "毛里塔尼亞"},
                {order: "136", value: "Mauritius", displayName: "毛里求斯"},
                {order: "137", value: "Mayotte", displayName: "馬約特"},
                {order: "138", value: "Mexico", displayName: "墨西哥"},
                {order: "139", value: "Micronesia", displayName: "密克羅尼西亞"},
                {order: "140", value: "Moldova", displayName: "摩爾多瓦"},
                {order: "141", value: "Monaco", displayName: "摩納哥"},
                {order: "142", value: "Mongolia", displayName: "蒙古"},
                {order: "143", value: "Montserrat", displayName: "蒙特塞拉特"},
                {order: "144", value: "Morocco", displayName: "摩洛哥"},
                {order: "145", value: "Mozambique", displayName: "莫桑比亞"},
                {order: "146", value: "Myanmar", displayName: "緬甸"},
                {order: "147", value: "Namibia", displayName: "納米比亞"},
                {order: "148", value: "Nauru", displayName: "瑙魯"},
                {order: "149", value: "Nepal", displayName: "尼泊爾"},
                {order: "150", value: "Netherlands", displayName: "荷蘭"},
                {order: "151", value: "Netherlands Antilles", displayName: "荷屬安的列斯"},
                {order: "152", value: "New Caledonia", displayName: "新喀里多尼亞"},
                {order: "153", value: "New Zealand", displayName: "新西蘭"},
                {order: "154", value: "Nicaragua", displayName: "尼加拉瓜"},
                {order: "155", value: "Niger", displayName: "尼日爾"},
                {order: "156", value: "Nigeria", displayName: "尼日利亞"},
                {order: "157", value: "Niue", displayName: "紐埃"},
                {order: "158", value: "Norfolk Island", displayName: "諾福克島"},
                {order: "159", value: "Northern Marianas", displayName: "北馬里亞納"},
                {order: "160", value: "Norway", displayName: "挪威"},
                {order: "161", value: "Oman", displayName: "阿曼"},
                {order: "162", value: "Pakistan", displayName: "巴基斯坦"},
                {order: "163", value: "Palau", displayName: "貝勞"},
                {order: "164", value: "Palestine", displayName: "巴勒斯坦"},
                {order: "165", value: "Panama", displayName: "巴拿馬"},
                {order: "166", value: "Papua New Guinea", displayName: "巴布亞新幾內亞"},
                {order: "167", value: "Paraguay", displayName: "巴拉圭"},
                {order: "168", value: "Peru", displayName: "秘魯"},
                {order: "169", value: "Philippines", displayName: "菲律賓"},
                {order: "170", value: "Pitcairn Islands Group", displayName: "皮特凱恩島"},
                {order: "171", value: "Poland", displayName: "波蘭"},
                {order: "172", value: "Portugal", displayName: "葡萄牙"},
                {order: "173", value: "Puerto Rico", displayName: "波多黎各"},
                {order: "174", value: "Qatar", displayName: "卡塔爾"},
                {order: "175", value: "Reunion", displayName: "留尼汪"},
                {order: "176", value: "Romania", displayName: "羅馬尼亞"},
                {order: "177", value: "Russia", displayName: "俄羅斯"},
                {order: "178", value: "Rwanda", displayName: "盧旺達"},
                {order: "179", value: "Saint helena", displayName: "聖赫勒拿"},
                {order: "180", value: "Saint Kitts and nevis", displayName: "聖基茨和尼維斯"},
                {order: "181", value: "Saint lucia", displayName: "聖盧西亞"},
                {order: "182", value: "Saint Pierre and Miquelon", displayName: "聖皮埃爾和密克隆"},
                {order: "183", value: "Saint Vincent and the Grenadines", displayName: "聖文森特和格林納丁斯"},
                {order: "184", value: "San Marion", displayName: "聖馬力諾"},
                {order: "185", value: "Sao Tome and Principe", displayName: "聖多美和普林西比"},
                {order: "186", value: "Saudi Arabia", displayName: "沙竺阿拉伯"},
                {order: "187", value: "Senegal", displayName: "塞內加爾"},
                {order: "188", value: "Seychells", displayName: "塞舌爾"},
                {order: "189", value: "Sierra leone", displayName: "塞拉利昂"},
                {order: "190", value: "Singapore", displayName: "新加坡"},
                {order: "191", value: "Slovakia", displayName: "斯洛伐克"},
                {order: "192", value: "Slovenia", displayName: "斯洛文尼亞"},
                {order: "193", value: "Solomon Islands", displayName: "所羅門群島"},
                {order: "194", value: "Somalia", displayName: "索馬里"},
                {order: "195", value: "South Africa", displayName: "南非"},
                {order: "196", value: "South Georgia and South Sandwich Islands", displayName: "南喬治亞島和南桑德韋奇島"},
                {order: "197", value: "Spain", displayName: "西班牙"},
                {order: "198", value: "Sri Lanka", displayName: "斯里蘭卡"},
                {order: "199", value: "Sudan", displayName: "蘇丹"},
                {order: "200", value: "Suriname", displayName: "蘇里南"},
                {order: "201", value: "Svalbard and jan Mayen Islands", displayName: "斯瓦爾巴群島"},
                {order: "202", value: "Swaziland", displayName: "斯威士蘭"},
                {order: "203", value: "Sweden", displayName: "瑞典"},
                {order: "204", value: "Switzerland", displayName: "瑞士"},
                {order: "205", value: "Syria", displayName: "敘利亞"},
                {order: "206", value: "Tajikistan", displayName: "塔吉克斯坦"},
                {order: "207", value: "Tanzania", displayName: "坦桑尼亞"},
                {order: "208", value: "Thailand", displayName: "泰國"},
                {order: "209", value: "Togo", displayName: "多哥"},
                {order: "210", value: "Tokelau", displayName: "托克勞"},
                {order: "211", value: "Tonga", displayName: "湯加"},
                {order: "212", value: "Trinidad and Tobago", displayName: "特立尼達和多巴哥"},
                {order: "213", value: "Tunisia", displayName: "突尼斯"},
                {order: "214", value: "Turkey", displayName: "土耳其"},
                {order: "215", value: "Turkmenistan", displayName: "土庫曼斯坦"},
                {order: "216", value: "Turks and Caicos Islands", displayName: "特克斯科斯群島"},
                {order: "217", value: "Tuvalu", displayName: "圖瓦盧"},
                {order: "218", value: "Uganda", displayName: "烏乾達"},
                {order: "219", value: "Ukraine", displayName: "烏克蘭"},
                {order: "220", value: "United Arab Emirates", displayName: "阿聯酋"},
                {order: "221", value: "United Kingdom", displayName: "英國"},
                {order: "222", value: "United States", displayName: "美國"},
                {order: "223", value: "Uruguay", displayName: "烏拉圭"},
                {order: "224", value: "Uzbekistan", displayName: "烏茲別克斯坦"},
                {order: "225", value: "Vanuatu", displayName: "瓦努阿圖"},
                {order: "226", value: "Vatican", displayName: "梵蒂岡"},
                {order: "227", value: "Venezuela", displayName: "委內瑞拉"},
                {order: "228", value: "Viet Nam", displayName: "越南"},
                {order: "229", value: "Wallis and Futuna Is-lands", displayName: "瓦利斯和富圖納群島"},
                {order: "230", value: "Western Sahara", displayName: "西撒哈拉"},
                {order: "231", value: "Western Samoa", displayName: "西薩摩亞"},
                {order: "232", value: "Yemen", displayName: "也門"},
                {order: "233", value: "Yugoslavia", displayName: "南斯拉夫"},
                {order: "234", value: "Zaire", displayName: "扎伊爾"},
                {order: "235", value: "Zambia", displayName: "贊比亞"},
                {order: "236", value: "Zimbabwe", displayName: "津巴布韋"}
            ];
                for (var i = 0; i < countries.length; i++){
                    if(countries[i].value == input){
                        return true;
                    }
                }
                return false;
            }
        });
        VeeValidate.Validator.extend("china_province", {
            getMessage: (field) => "請填寫或選擇正確的" + field,
            validate: (input, args) => {
                const chinaProvinces = [
                    {order: "1", value: "ANHUI", displayName: "安徽"},
                    {order: "2", value: "BEIJING", displayName: "北京"},
                    {order: "3", value: "CHONGQING", displayName: "重慶"},
                    {order: "4", value: "FUJIAN", displayName: "福建"},
                    {order: "5", value: "GANSU", displayName: "甘肅"},
                    {order: "6", value: "GUANGDONG", displayName: "廣東"},
                    {order: "7", value: "GUANGXI", displayName: "廣西自治區"},
                    {order: "8", value: "GUIZHOU", displayName: "貴州"},
                    {order: "9", value: "HAINAN", displayName: "海南"},
                    {order: "10", value: "HEBEI", displayName: "河北"},
                    {order: "11", value: "HEILONGJIANG", displayName: "黑龍江"},
                    {order: "12", value: "HENAN", displayName: "河南"},
                    {order: "13", value: "HUBEI", displayName: "湖北"},
                    {order: "14", value: "HUNAN", displayName: "湖南"},
                    {order: "15", value: "INNER MONGOLIA", displayName: "內蒙古自治區"},
                    {order: "16", value: "JIANGSU", displayName: "江蘇"},
                    {order: "17", value: "JIANGXI", displayName: "江西"},
                    {order: "18", value: "JILIN", displayName: "吉林"},
                    {order: "19", value: "LIAONING", displayName: "遼寧"},
                    {order: "20", value: "NINGXIA", displayName: "寧夏自治區"},
                    {order: "21", value: "QINGHAI", displayName: "青海"},
                    {order: "22", value: "SHAANXI", displayName: "陝西"},
                    {order: "23", value: "SHANDONG", displayName: "山東"},
                    {order: "24", value: "SHANGHAI", displayName: "上海"},
                    {order: "25", value: "SHANXI", displayName: "山西"},
                    {order: "26", value: "SICHUAN", displayName: "四川"},
                    {order: "27", value: "TAIWAN", displayName: "台灣"},
                    {order: "28", value: "TIANJIN", displayName: "天津"},
                    {order: "29", value: "TIBET", displayName: "西藏自治區"},
                    {order: "30", value: "XINJIANG", displayName: "新疆自治區"},
                    {order: "31", value: "YUNNAN", displayName: "雲南"},
                    {order: "32", value: "ZHEJIANG", displayName: "浙江"},
                    {order: "33", value: "Others", displayName: "其他/不在此列表"},
                    {order: "none", value: "N/A", displayName: "不適用（此項不應在客戶Display）"}
                ];
                for (var i = 0; i < chinaProvinces.length; i++){
                    if(chinaProvinces[i].value == input){
                        return true;
                    }
                }
                return false;
            }
        });
        VeeValidate.Validator.extend("required_choose", {
            getMessage: (field) => "請選擇" + field,
            validate: (input, args) => {
                if(input.length > 0){
                    return true;
                }else{
                    return false;
                }
            }
        });
        VeeValidate.Validator.extend("upload", {
            getMessage: (field) => "請" + field,
            validate: (input, args) => {
                if(input == ""){
                    return false;
                }else{
                    return true;
                }
            }
        });
        VeeValidate.Validator.extend("agreement", {
            getMessage: (field) => "請務必同意" + field + "，如不同意可直接點擊左上離開鍵中止申請",
            validate: (input, args) => {
                if(input === false){
                    return false;
                }else if(input === true){
                    return true;
                }
            }
        });
        VeeValidate.Validator.extend("phone", {
            getMessage: (field) => "請填寫有效" + field,
            validate: (input, args) =>{
                return isValidNumber(input, intPhoneMetadata);
            }
        });
        VeeValidate.Validator.extend("mobile", {
            getMessage: (field) => "請填寫有效" + field,
            validate: (input, args) =>{
                if(getNumberType(input, intPhoneMetadata) === "MOBILE"){
                    return isValidNumber(input, intPhoneMetadata);
                }else{
                    return false;
                }
            }
        });
        VeeValidate.Validator.extend("bus_phone", {
            getMessage: (field) => "請填寫有效" + field,
            validate: (input, args) =>{
                if(getNumberType(input, intPhoneMetadata) !== "MOBILE"){
                    return isValidNumber(input, intPhoneMetadata);
                }else{
                    return false;
                }
            }
        });
    },
    render: h => h(App)
});
